import Immutable from 'immutable';

const Content: {
  disableShowDialogGoToJobFolder: boolean
} = {
  disableShowDialogGoToJobFolder: false
};

class WarningsSettings extends Immutable.Record(Content) {
}

export default WarningsSettings;
